import '../sass/style.scss';
import videojs from 'video.js';
import 'videojs-youtube';
import './lib/slick-functions.js';
import './lib/utils.js';
import './lib/search.js';
import './lib/accessibility.js';
import './lib/map.js';
import './lib/plugins/lazy-sizes.js';
import './lib/plugins/slick.js';
import './lib/plugins/lity.js';

import Personalisation from './personalisation/personalisation';

import lottie from "lottie-web";
import { defineElement } from "@lordicon/element";

(function($) {

    $(document).ready(function() {

        const personalisationData = {
            postID: props.postID,
            postType: props.postType,
            businessArea: props.personalisation.businessArea || false,
            areaOfWork: props.personalisation.areaOfWork || false,
            location: {
                country: props.personalisation.location?.country || null,
                ip: props.personalisation.location?.ip || null,
            }
        };        

        new Personalisation(personalisationData);

        // Lordicon Animations
        defineElement(lottie.loadAnimation);

        // Top button for accessibility
        $(window).scroll(function () {
            if ($(window).scrollTop() > 300) {
                $('#top-link').addClass('show');
            } else {
                $('#top-link').removeClass('show');
            }
        });

        $('body').on('click', '#top-link', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 500);
        });

        // Add toggle button for mobile dropdowns
        $('.menu-item-has-children').append('<div class="g__header__sub__toggle"><span class="sr-only">Open Dropdown</span></div>');

        $('.menu-item-has-children .g__header__sub__toggle').on('click', function(){
            var sub_menu = $(this).parent().find('.sub-menu');

            if( $(sub_menu).hasClass('open') ){
                $(sub_menu).removeClass('open');
            }else{
                $(sub_menu).addClass('open');
            }
        });

        // Initial call to add sticky header
        stickyHeader();

        // Make sticky on
        $(window).bind('scroll', function () {
            stickyHeader();
        });

        $('input[id^="accordionInput"]').change(function() {
            $(this).parents('.b__accordion').find('input[type="checkbox"]').not($(this)).prop('checked', false);

            if ($(this).prop('checked')) {

                const parent = $(this).closest('.b__accordion-item');

                setTimeout(() => {
                    $('html, body').animate({
                        scrollTop: parent.offset().top - 200
                    }, 300);
                }, 50); // 30–80ms usually works
            }
        });

        $('.b__accordion-item__title span').on('click', function () {
            $(this).prev('button').trigger('click');
        });

        $('.b__accordion-trigger').on('click', function () {
            const $btn = $(this);
            const expanded = $btn.attr('aria-expanded') === 'true';
            const panelId = $btn.attr('aria-controls');
            const $panel = $('#' + panelId);

            // Close all others
            if( ! $(this).hasClass('jobs-accordion') ){
                $('.b__accordion-trigger').not($btn).attr('aria-expanded', 'false');
                $('.b__accordion-item__content').not($panel).attr('hidden', true);
            }

            // Toggle this one
            $btn.attr('aria-expanded', expanded ? 'false' : 'true');
            $panel.attr('hidden', expanded);

            // Scroll if opening
            if (!expanded) {
                const parent = $btn.closest('.b__accordion-item');

                setTimeout(() => {
                    $('html, body').animate(
                        { scrollTop: parent.offset().top - 200 },
                        300
                    );
                }, 50);
            }
        });



        $('.b__video--file').each(function(){
            var player = videojs($(this).find('video').attr('id'));

            player.ready(function() { 
                // Find the poster image button
                var posterEl = player.el().querySelector('.vjs-poster');

                if (posterEl) {
                    // Set an accessible label
                    posterEl.setAttribute('aria-label', 'Play video');
                }
            });
        });

        $('.b__videoCarousel--item').each(function(){
            var player = videojs($(this).find('video').attr('id'));
            var parent = $(this);
            var button = $(this).find('.play-btn');
            var poster = $(this).find('.vjs-poster');

            player.on('play', function(){
                $(button).addClass('hidden');
                $(parent).siblings().each(function(){
                    var video = videojs($(this).find('video').attr('id'));

                    video.pause();
                    video.currentTime(0);
                });
            });

            player.on('pause', function(){
                $(button).removeClass('hidden');
                $(poster).removeClass('vjs-has-started');
            });
        });

        $(document).on('click', '.b__video .c__btn--play', function(){
            $(this).parents('.b__video').addClass('played');
            $(this).parents('.b__video').find('.vjs-big-play-button').trigger('click');
        });

        $(document).on('click', '.c-dashboard-video__player .play-btn', function(){
            $(this).parents('.c-dashboard-video__player').find('.vjs-big-play-button').trigger('click');
            $(this).parents('.c-dashboard-video__player').addClass('played');
        });

        $(document).on('click', '.b__videoCarousel .play-btn', function(){
            $(this).parents('.b__videoCarousel--item').find('.vjs-big-play-button').trigger('click');
        });

        // Video JS accessibility
        $('.vjs-poster').attr('role', 'button');
        $('.vjs-poster').attr('tabindex', '0');

        // $('.vjs-modal-dialog.vjs-hidden.vjs-text-track-settings').remove();
        // Remove unused VJS divs
        $('.vjs-hidden').remove();
        
        // Parallax effect function
        function parallaxEffect() {
            var scrolled = $(window).scrollTop();
            $('.parralax').css({
                'transform': 'translateY(' + (scrolled * 0.3) + 'px)'  // Adjust speed factor (0.3)
            });
        }
    
        // Listen for scroll event
        $(window).on('scroll', parallaxEffect);
        
        
        $('input[name=subnav-toggles').on('change', function(){
            $('input[name="subnav-toggles"]').not(this).prop('checked', false);
        });

        // Cycle through words in Hero
        const $wordsCycle = $('#words-cycle');

        // Check if #words-cycle exists and has the `data-words` attribute
        if ($wordsCycle.length && $wordsCycle.data('words')) {
            const words = $wordsCycle.data('words'); // Get the words array from the data attribute
            let wordIndex = 0;
            let charIndex = 0;
            const typingSpeed = 200; // Typing speed in ms
            const pauseBetweenWords = 1500; // Pause between words in ms

            function typeWord() {
                if (charIndex < words[wordIndex].length) {
                    $wordsCycle.append(words[wordIndex].charAt(charIndex));
                    charIndex++;
                    setTimeout(typeWord, typingSpeed);
                } else {
                    setTimeout(eraseWord, pauseBetweenWords);
                }
            }

            function eraseWord() {
                if (charIndex > 0) {
                    $wordsCycle.text($wordsCycle.text().slice(0, -1));
                    charIndex--;
                    setTimeout(eraseWord, typingSpeed / 2);
                } else {
                    wordIndex = (wordIndex + 1) % words.length;
                    setTimeout(typeWord, typingSpeed);
                }
            }

            // Start typing the first word
            typeWord();
        }

        // function calculateOffsets() {
        //     sectionOffsets = {};
        //     $('section[id]').each(function () {
        //         sectionOffsets['#' + this.id] = $(this).offset().top;
        //     });
        // }

        // $(window).on('load resize', calculateOffsets);

        // $('[data-slick]').on('init', function() {
        //     calculateOffsets(); // re-measure all section positions
        // });

        // // Store nav links
        // var navLinks = $('.c__single__job--nav--item');

        // // Get offset of each link
        // var sectionOffsets = {};
        // navLinks.each(function() {
        //     var id = $(this).attr('href');
        //     sectionOffsets[id] = $(id).offset().top - 200;
        // });

        // // Function to update active class based on scroll position
        // function updateActiveSection() {
        //     var scrollPosition = $(document).scrollTop();
        //     var windowHeight = $(window).height();
        //     var documentHeight = $(document).height();
        //     var offsetAdjustment = 0;

        //     // If body has .text-large, delay the active section trigger
        //     if ($('body').hasClass('text-large')) {
        //         offsetAdjustment = windowHeight * 0.40;
        //     }else {
        //         // Trigger a bit earlier for normal text
        //         offsetAdjustment = windowHeight * 0.15; // make section active slightly sooner
        //     }

        //     // Check if user has scrolled to the very bottom of the page
        //     if (scrollPosition + windowHeight >= documentHeight) {
        //         navLinks.parents('li').addClass('active');
        //         return;
        //     }

        //     // Iterate through section offsets
        //     $.each(sectionOffsets, function(sectionId, offset) {
        //         if (scrollPosition + offsetAdjustment >= offset) {
        //             $('a[href="' + sectionId + '"]').parents('li').addClass('active');
        //         } else {
        //             $('a[href="' + sectionId + '"]').parents('li').removeClass('active');
        //         }
        //     });
        // }


        // // Initial call to update active section on page load
        // updateActiveSection();

        // // Listen for scroll events and update active section accordingly
        // $(window).scroll(function() {
        //     updateActiveSection();
        // });

    var navLinks = $('.c__single__job--nav--item');
    var sectionOffsets = {};

    function calculateOffsets() {
        sectionOffsets = {};
        $('section[id]').each(function () {
            sectionOffsets['#' + this.id] = $(this).offset().top;
        });
    }

    function updateActiveSection() {
        var scrollPosition = $(document).scrollTop();
        var windowHeight = $(window).height();
        var documentHeight = $(document).height();
        var offsetAdjustment = $('body').hasClass('text-large')
            ? windowHeight * 0.4
            : windowHeight * 0.15;

        // Handle bottom of page
        if (scrollPosition + windowHeight >= documentHeight - 5) {
            navLinks.parents('li').addClass('active');
            return;
        }

        // Loop through each section and add active if reached
        $.each(sectionOffsets, function(sectionId, offset) {
            var $navItem = $('a[href="' + sectionId + '"]').parents('li');
            if (scrollPosition + offsetAdjustment >= offset) {
                $navItem.addClass('active');
            } else {
                $navItem.removeClass('active');
            }
        });
    }

    // Initial setup
    calculateOffsets();
    updateActiveSection();

    // Recalculate on load, resize, and slider init
    $(window).on('load resize', function() {
        calculateOffsets();
        updateActiveSection();
    });

    $('[data-slick]').on('init', function() {
        calculateOffsets();
        updateActiveSection();
    });

    // Update on scroll
    $(window).on('scroll', updateActiveSection);

        $(document).on('click', '.b__linkBlock__grid__item--img a', function(e){
            if ($(window).width() < 1025) {
                e.preventDefault();
            }
        });

        $(document).on('change', '#toggle-filters', function(){
            if ($(this).is(':checked')) {
                $('.c__listings__filters--dropdown').addClass('open');
            } else {
                $('.c__listings__filters--dropdown').removeClass('open');
            }
        });

        $(document).on('change', '.subnav-toggle', function(){
            var checkboxID = $(this).attr('id');  // Get the ID of the checkbox
            var label = $('label[for="' + checkboxID + '"]').parents('fieldset');  // Get the label element using the checkbox ID

            if( $(this).is(':checked') ){
                label.attr('aria-expanded', 'true');  
            }else{
                label.attr('aria-expanded', 'false'); 
            }
        });

        $(document).on('change', '#toggle-filters', function(){
            var checkboxID = $(this).attr('id');  // Get the ID of the checkbox
            var label = $('label[for="' + checkboxID + '"]');  // Get the label element using the checkbox ID

            if( $(this).is(':checked') ){
                label.attr('aria-expanded', 'true');  
            }else{
                label.attr('aria-expanded', 'false'); 
            }
        });

        $(document).on('change', 'input[type=checkbox]', function(){
            var checkbox = $(this);  // Reference to the checkbox
            var label = $('label[for="' + checkbox.attr('id') + '"]');  // Get the label for the checkbox
            
            // Check if the label exists and has the aria-expanded attribute
            if (label.length && label.attr('aria-expanded') !== undefined) {
              // If checkbox is checked, set aria-expanded to true, otherwise false
              if (checkbox.is(':checked')) {
                label.attr('aria-expanded', 'true');
              } else {
                label.attr('aria-expanded', 'false');
              }
            }
        });

        $('.wp-block-image figure').attr('role', 'none');

        // Check if the URL contains a hash and if it contains 'vacancies-listing'
        if (window.location.hash && window.location.hash.indexOf('vacancies-listing') !== -1) {
            // Get the target element based on the URL hash
            var targetElement = $(window.location.hash);
    
            // If the target element exists, scroll 200px above it
            if (targetElement.length) {
                // Directly set the scroll position without animation
                $('html, body').scrollTop(targetElement.offset().top - 200);
            }
        }

        // Check if the URL contains a hash and if it contains 'vacancies-listing'
        if (window.location.hash && window.location.hash.indexOf('blogs-listing') !== -1) {
            // Get the target element based on the URL hash
            var targetElement = $(window.location.hash);
    
            // If the target element exists, scroll 200px above it
            if (targetElement.length) {
                // Directly set the scroll position without animation
                $('html, body').scrollTop(targetElement.offset().top - 200);
            }
        }

        if( $('#random-image').length ){
            $('#random-image').each(function(){
                var images_string = $(this).data('images');

                var images = JSON.parse( images_string );

                console.log('test');

                // Generate a random index
                var randomIndex = Math.floor(Math.random() * images.length);
                
                // Get the random image object using the random index
                var randomImage = images[randomIndex];
                
                // Now you can use randomImage as needed, for example:
                console.log(randomImage); // This will log the image data at the random index
            });
            
        }

        if( $('.b__hero__home--img').length ){
            var images = $('.b__hero__home--img');
            var randomIndex = Math.floor(Math.random() * images.length);
    
            $(images[randomIndex]).addClass('active');
        }
    });

    // Disable top level nav items with no link
    $(document).on('click', '.menu-item-has-children a', function(e){
        if( $(this).attr('href') === '#' ){
            e.preventDefault();
        }
    });

    /**
     * Job search for all pages
     */

    $(document).on('click', '.b__tabs label', function(){
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
    });
    
    $(document).on("change", '.b__tabs select', function(e) { 
		e.preventDefault(); 
		var tab_val = $(this).val();
		$("input[type=radio]#" + tab_val + "").prop('checked', true);
		$("input[type=radio]#" + tab_val + "").trigger('change');
		$('.b__tabs__bar label').removeClass('active');
		$('.b__tabs__bar label[for='+ tab_val +']').addClass('active');
	});

    $(document).on("change", '.b__tabs input[type=radio], .b__tabs select', function() { 
		$('[data-slick]').slick('refresh');
	});

    $(document).on('click', function(e) {
        // Check if the clicked target is NOT #accessibility-toggle or a child of it
        if (!$(e.target).closest('.g__nav__item.has-children').length) {
            // Your code for handling clicks outside of #accessibility-toggle
            $('input[name="subnav-toggles"]').prop('checked', false);
            $('input[name="subnav-toggles"]').trigger('change');

        }
    });

    $(document).on('change', '.subnav-toggle', function(){
        var isChecked = $(this).is(':checked');

        // Find the associated label (assuming it’s a sibling label *for* this input)
        var label = $('label[for="' + this.id + '"]');

        // Update aria-expanded
        label.attr('aria-expanded', isChecked ? 'true' : 'false');
    });

    $(document).on('click', function(e) {
        // Check if the clicked target is NOT #accessibility-toggle or a child of it
        if (!$(e.target).closest('.c__listings__filters--dropdown').length) {
            // Your code for handling clicks outside of #accessibility-toggle
            $('#toggle-filters').prop('checked', false);
            $('#toggle-filters').trigger('change');

        }
    });

    $(document).on('click', '.copy-link', function(){
        var currentUrl = window.location.href;

        // Create a temporary input element to hold the URL
        var tempInput = $('<input>');
        $('body').append(tempInput);
        tempInput.val(currentUrl).select(); // Set the value and select it

        // Copy the selected text to the clipboard
        document.execCommand('copy');

        // Remove the temporary input element
        tempInput.remove();

        $('.copy-link .message p').text('Copied to clipboard');
    });

    $(document).on('change', '.tab-toggle-input', function(){
        if( $(this).prop('checked') ){
            var target = '#' + $(this).data('target');

            $(this).parents('.b__tabs').find('.b__tabs__item').removeClass('active');
            $(target).addClass('active');

        }
    });

    headerMargin();

    $(document).on('click', '.b__savedJobs .c__job .js-save-job', function(){
        location.reload();
    });

    $(window).resize(function() {
        headerMargin();
    });

    $(document).on('change', '#mobile-toggle', function() {
        setTimeout(function() {
            headerMargin();
        }, 300); // 300ms delay

        if( $(this).prop('checked') ){
            $('body').addClass('nav-open');
        }else{
            $('body').removeClass('nav-open');
        }
    });

    $(document).on('keydown', '.b__accordion-item__title', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); // Prevent page scroll on Space
            $(this).trigger('click');
        }
    });

    
    // Sync aria-expanded / aria-hidden when the checkbox changes
    $(document).on('change', '#filters-accordion', function () {
    const expanded = this.checked;
    $('#filters-accordion-btn').attr('aria-expanded', expanded ? 'true' : 'false');
    $('#filters-panel').attr('aria-hidden', expanded ? 'false' : 'true');
    });

    // Make the label keyboard-activatable (Enter/Space)
    $(document).on('keydown', '#filters-accordion-btn', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); // prevent page scroll on Space
            const $cb = $('#filters-accordion');
            $cb.prop('checked', !$cb.prop('checked')).trigger('change');
        }
    });

    // Make Enter or Space trigger click on tabbable labels
    $(document).on('keydown', '.b__tabs__bar label', function (e) {
        // Check for Enter (13) or Space (32)
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault(); // prevent page scroll when pressing space
            $(this).click();    // trigger same behaviour as click
        }
    });


    // (Optional) initialize on load in case checkbox has default state
    $(function () {
        $('#filters-accordion').trigger('change');
    });



    function stickyHeader() {
        var scroll_target = 1;

        if( $('body').hasClass('single-jobs') ){
            scroll_target = 370;
        }

        if ($(window).scrollTop() > scroll_target) {
            $('.g__header').addClass('sticky');
            $('.c__single__job--nav').addClass('sticky');
        } else {
            $('.g__header').removeClass('sticky');
            $('.c__single__job--nav').removeClass('sticky');
        }
    }

    function headerMargin(){
        var header_height = $('.g__header').height();

        $('.site-main').css('margin-top', header_height);
    }
    
}(jQuery));
